module.exports = __webpack_public_path__ + "static/media/LogicLever2_2_drag_2.54e520a8.png";